(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hue-colors"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hue-hue-picker')) {
  class HueHuePicker extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.controls = this.querySelector('[data-color-controls]');
      this.grid = this.querySelector('[data-hue-grid]');
      if (!this.controls || !this.grid) return;

      this.cards = [];
      const products = new Map();

      this.grid.querySelectorAll('[data-color-card]').forEach((card) => {
        const colors = (card.dataset.colorGroups || card.dataset.colorCard || '').split(',').filter(Boolean);
        const existing = products.get(card.dataset.productId);

        if (existing) {
          existing.dataset.colorGroups = [...new Set([...existing.dataset.colorGroups.split(','), ...colors])].join(',');

          if (existing.dataset.shortTitle !== 'true' && card.dataset.shortTitle === 'true') {
            existing.querySelector('h3 a').textContent = card.querySelector('h3 a').textContent;
            existing.dataset.shortTitle = 'true';
          }

          card.remove();
        } else {
          card.dataset.colorGroups = [...new Set(colors)].join(',');
          products.set(card.dataset.productId, card);
          this.cards.push(card);
        }
      });

      if (!this.cards.length) return;

      const order = (this.dataset.productOrder || '').split(',').filter(Boolean);
      const positions = new Map(order.map((id, index) => [id, index]));

      this.cards.sort((a, b) =>
        (positions.get(a.dataset.productId) ?? order.length) -
        (positions.get(b.dataset.productId) ?? order.length)
      );

      this.cards.forEach((card) => this.grid.append(card));

      const available = new Set(
        [...this.controls.querySelectorAll('[data-color-filter]')]
          .map((button) => button.dataset.colorFilter)
      );

      this.selected = new Set(
        [...(this.selected || [])]
          .filter((color) => color !== 'all' && available.has(color))
      );

      this.clickHandler = (event) => {
        if (!(event.target instanceof Element)) return;

        const arrow = event.target.closest('[data-hue-scroll]');

        if (arrow && this.contains(arrow)) {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.grid.scrollBy({
            left: Number(arrow.dataset.hueScroll) * this.grid.clientWidth * .9,
            behavior: reduced ? 'auto' : 'smooth'
          });

          return;
        }

        const button = event.target.closest('[data-color-filter]');
        if (!button || !this.controls.contains(button)) return;

        const color = button.dataset.colorFilter;

        if (color === 'all') this.selected.clear();
        else if (this.selected.has(color)) this.selected.delete(color);
        else this.selected.add(color);

        this.update(true);
      };

      this.scrollHandler = () => this.updateArrows();

      this.addEventListener('click', this.clickHandler);
      this.grid.addEventListener('scroll', this.scrollHandler, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.grid);

      this.controls.hidden = false;
      this.querySelector('[data-color-hint]').hidden = false;
      this.querySelector('[data-hue-navigation]').hidden = false;

      this.update(false);
    }

    update(announce) {
      const all = this.selected.size === 0;
      const labels = [];

      this.controls.querySelectorAll('[data-color-filter]').forEach((button) => {
        const color = button.dataset.colorFilter;
        const active = color === 'all' ? all : this.selected.has(color);

        button.setAttribute('aria-pressed', String(active));

        if (active && color !== 'all') labels.push(button.textContent.trim());
      });

      let count = 0;

      this.cards.forEach((card) => {
        const matches = all ||
          card.dataset.colorGroups.split(',')
            .some((color) => this.selected.has(color));

        card.hidden = !matches;

        if (matches) count += 1;
      });

      if (announce) {
        this.grid.scrollLeft = 0;

        const selection = all ? 'All colors' : labels.join(', ');

        this.querySelector('[data-color-status]').textContent =
          selection + ': ' + count + ' ' +
          (count === 1 ? 'piece' : 'pieces') + ' shown.';
      }

      this.updateArrows();
    }

    updateArrows() {
      if (!this.grid) return;

      const end = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);

      this.querySelector('[data-hue-scroll="-1"]').disabled =
        this.grid.scrollLeft <= 2;

      this.querySelector('[data-hue-scroll="1"]').disabled =
        this.grid.scrollLeft >= end - 2;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.removeEventListener('click', this.clickHandler);
      this.grid?.removeEventListener('scroll', this.scrollHandler);
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('hue-hue-picker', HueHuePicker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
